// extracted by mini-css-extract-plugin
export default {"changeLangs":"ChangeLang_changeLangs__DAh3r","langBtn":"ChangeLang_langBtn__+lKkq"};